import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import '../appComponents/desktop/css/PlatformFooterDesktop.css';
import DesktopTransferPanel from '../appComponents/desktop/DesktopTransferPanel';
import '../appComponents/desktop/css/DesktopModalStyles.css';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import './css/BrowserListsUnified.css';
import './css/BrowserSearchPolish.css';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import PasswordPrompt from '../appComponents/shared/crypto/PasswordPrompt';
import CryptoMoneyPanel from '../appComponents/shared/crypto/CryptoMoneyPanel';
import React, { Component } from 'react';

class BrowserDesktopRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Browser, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Chart, Component, Container, CryptoJS, ErrorBoundary, Form, FormField, Fragment, Header, Icon, Image, LENDERBLOCKADMINWHITELIST, LeftNavBar, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PIXELAJUST, Radio, React, ReactSearchAutocomplete, Storage, ThreeDot, USDEtherConversionRate, Web3, addedContracts, addedContracts_creditLine, addedContracts_loanAgreement, allBorrowerUsernamesDisplayNames, allContracts, allContractsLooper, allDaysElapsed, allValues, applicantUsername, awsconfig, axios, bScoreFilterMax, bScoreFilterMin, blenderCommissionPublicKey, blenderData, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, cardEntryFormTimer, cardFundComponent, chartData, chartDayRange, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, city, className, cognitoID, compoundedDebtSum, corporateBackedUsernamesArray, country, countryCodeSwappedJSON, countryCodeSwappedJSONList, countryCodes, countryNames, creditLineAddressArray, creditLineArray, currentLentSum, currentUser, currentUserCap, debounce, emailAddress, ethers, exitFundWalletTimer, exitTutorialTimer_1, exitTutorialTimer_2, exitTutorialTimer_3, filterSwitch, filterSwitchReloaded, firstName, flashCounter, forexJSON, fullAddress, fullName, fundWalletPromptDidBool, highRateWeb3, intRateMax, intRateMin, isMobile, isSubscribedCurrentBool, joinDateSecs, lastName, lastNonce, lenderCtMax, lenderCtMin, lenders, loanAgreementArray, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, newMemberRegisterBool, noAccountsWarning_creditLine, noAccountsWarning_loanAgreement, notificationCount, notifs, openBorrowingContractsDetails_loanAgreement, openContracts, openLendingContractsDetails_loanAgreement, openStakingContractsDetails_loanAgreement, optionCountryCodeSwappedJSON, pageOrigin, postalCode, preSortedContractsArray, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, rand2, rand3, rand4, randSum, ratingMax, ratingMin, recentlyViewedContracts, recentlyViewedContractsArray, resultMessageTimer, retrievedContractsArray, routeProps, scrollHeaderInterval, searchTimer, secondaryDisplayCurrency, secondaryDisplayPrice, squareCustomerID, stakedContractsList, state, street, that, tokenID, tokenLifeTimeLimit, topMoversArray, totalBorrContracts, touched, useLayoutEffect, useParams, useRef, userWishlist, username_wallet, verifyOverlayShownBool, walletBalance, walletBalanceWei, web3, wishlistArray } = this.props;

    // Existing Browser.js loads this array from DynamoDB general / userArray.
    const browserSearchQuery = String(that.state.search || '').trim().toLowerCase();
    const browserSearchSuggestions = browserSearchQuery
      ? (Array.isArray(that.state.allUserUsernamesDisplayNames) ? that.state.allUserUsernamesDisplayNames : [])
          .map((entry) => ({name: String(typeof entry === 'string' ? entry : entry?.name || '').trim()}))
          .filter((entry) => entry.name && entry.name.toLowerCase().includes(browserSearchQuery))
          .sort((first, second) => {
            const a = first.name.toLowerCase().startsWith(browserSearchQuery) ? 0 : 1;
            const b = second.name.toLowerCase().startsWith(browserSearchQuery) ? 0 : 1;
            return (a - b) || first.name.localeCompare(second.name);
          })
          .slice(0, 8)
      : [];

    return (
(
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--browser tbp-platform--desktop" + (that.state.searchSubmitted ? " tbp-browser--search-submitted" : "")}>
              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            


            

            
            

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.pendingTransactionLoaderOverlay}
              // open={true}
              style={{
                width: '18vw',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginLeft: '2vw',
                      marginRight: '3vw',
                      marginTop: '0vw',
                      marginBottom: '0vw',
                      height: '5vw',
                    }}
                  >
                    <p
                      style={{
                        fontSize: 19,
                        color: 'rgba(0, 0, 0, 1)',
                        textAlign: 'left',
                        marginBottom: '2vh',
                      }}
                    >
                      {
                        that.state.selectedLanguage == 'spanish' 
                        ? 
                          "Transacción Pendiente"
                        :
                          "Transaction in Progress"
                      }
                    </p>
                    
                    <div
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '4vw',
                        marginLeft: '3vw',
                        marginRight: '3vw',
                        // paddingLeft: '5vw',
                        // paddingRight: '5vw', 
                      }}
                    >
                      <div className="tbp-overlay-loading"><ThreeDot 
                        color="rgba(0, 158, 129, 1)" 
                        size="large" 
                        style={{
                          marginTop: 250,
                          speedPlus: -2,
                        }}
                      /></div>
                    </div>
                  
                  </Header>
                  
                </Modal.Description>
                
              </Modal.Content>
            </Modal>

        
            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.errorTags}
                // open={true}
                style={{
                    width: '84vw',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Modal.Header
                    style={{
                        paddingLeft: '7vh',
                    }}
                >
                    <img
                        src={'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png'} 
                        style={{
                            left: '3vw',
                            paddingRight: '2vw',
                            position: 'absolute',
                            borderRadius: '0.25',
                            height: '2.75vh',
                            weight: '2.75vh',
                        }}
                    />
                    <p
                        style={{
                            color: 'rgba(0, 0, 0, 1)',
                            textAlign: 'left',
                            textWrap: 'wrap',
                            marginLeft: '8vw',
                            fontSize: '17px'
                        }}
                    >
                        The Blender Platform
                    </p>
                </Modal.Header>
                
                <Modal.Content 
                    image
                    style={{
                        justifyContent: 'space-between',
                        marginBottom: '0vh',
                    }}
                >
                    
                    <Modal.Description
                        style={{
                        width: '84vw',
                        }}
                    >
                        <Header
                        style={{
                            // left: '16vw',
                            fontSize: 17,
                            // position: 'absolute',
                            overflowY: 'hidden',
                            overflowX: 'hidden', 
                            width: '84vw',
                            marginBottom: 65,
                            paddingRight: '3vw',
                        }}
                        >
                            <p
                            style={{
                                color: 'rgba(235, 50, 38, 1)',
                                textAlign: 'left',
                                textWrap: 'wrap',
                                fontWeight: '600',
                                fontSize: 16,
                            }}
                            >
                            {that.state.selectedLanguage == 'spanish' ? 
                                'Error:'
                                    :
                                'Error:'
                            }
                            </p>
                            <p
                            style={{
                                color: 'rgba(0, 0, 0, 1)',
                                textAlign: 'left',
                                textWrap: 'wrap',
                                fontWeight: '600',
                                fontSize: 16,
                                marginRight: '2vw',
                            }}
                            >
                            {that.state.errorTags}
                            </p>
                        </Header>
                    
                        <Button
                            content={
                                that.state.selectedLanguage == 'spanish' ? 
                                'Bueno'
                                    :
                                'Okay'
                            }
                            // labelPosition='right'
                            // icon='checkmark'
                            onClick={() => {
                                that.setState({
                                    successfulDepositOverlay: false,
                                    errorTags: null
                                })
                            }}
                            positive
                            style={{
                                backgroundColor: 'rgba(0, 158, 129, 1)',
                                position: 'relative',
                                bottom: '0vh',
                                fontSize: 13,
                                width: '27vw',
                                marginLeft: '25.5vw',
                                marginRight: '25.5vw',
                                // left: '0vw',
                                borderRadius: 3,
                            }}
                        />
                    </Modal.Description>
                </Modal.Content>
            </Modal>
              
              
            <PasswordPrompt desktop
              open={that.state.showPasswordOverlay}
              theme={that.state.mode_light_dark}
              language={that.state.selectedLanguage}
              message={that.state.transactionConfirmationMessage}
              value={that.state.passwordText || ''}
              onChange={(event) => {
                          that.setState({
                            passwordText: event.target.value
                          })
                      }}
              onConfirm={() => {
                        that.setState({
                          showPasswordOverlay: false,
                          pendingTransactionLoaderOverlay: true,
                        })
                        if(that.state.moneyTransactionPreset == 'deposit'){
                          that.chargeUserLinked()
                        } else if(that.state.moneyTransactionPreset == 'transfer'){
                          that.sendTransferFinal()
                        } else if(that.state.moneyTransactionPreset == 'withdrawal'){
                          that.withdrawEther()
                        }
                      }}
              onCancel={() => {
                that.setState({
                  showPasswordOverlay: false,
                  passwordText: null,
                  passwordIsHiddenBool: true,
                })
              }}
            />


            <Modal
              centered={true}
              dimmer={{ className: "tbp-overlay-backdrop" }}
              className="tbp-desktop-social-modal" open={that.state.socialOverlay}
              style={{
                width: 'min(1050px, 92vw)',
                maxWidth: 1050,
                height: 'auto',
                maxHeight: '90vh',
                padding: 0,
                margin: '0 auto',
                overflow: 'hidden',
                borderRadius: 14,
                boxSizing: 'border-box',
                backgroundColor:
                  that.state.mode_light_dark == 'light'
                    ? '#e0e1e2'
                    : '#232324',
                color:
                  that.state.mode_light_dark == 'light'
                    ? '#171717'
                    : '#ffffff',
              }}
            >
              <div
                style={{
                  width: '100%',
                  maxHeight: '90vh',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  backgroundColor:
                    that.state.mode_light_dark == 'light'
                      ? '#e0e1e2'
                      : '#232324',
                }}
              >

                {/* TOP BAR */}
                <div
                  style={{
                    minHeight: 54,
                    padding: '10px 14px',
                    boxSizing: 'border-box',
                    backgroundColor: 'rgba(0, 158, 129, 1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <button
                    onClick={() => {
                      that.setState({
                        socialOverlay: false,
                        socialOverlayData_username: null,
                        socialOverlayData_fullName: null,
                        socialOverlayData_imageURI: null,
                        socialOverlayData_bioString: null,
                        socialOverlayData_contractAddress: null,
                        mediaMapArray: null,
                        commentReplyID: null,
                        commentInitMediaFileName: null,
                        newCommentStringInput: null,
                      })
                    }}
                    style={{
                      width: 38,
                      height: 38,
                      border: 0,
                      borderRadius: 19,
                      backgroundColor: 'rgba(204, 12, 12, 0.95)',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <i
                      className="close icon"
                      style={{ margin: 0, fontSize: 17 }}
                    />
                  </button>

                  <div
                    style={{
                      color: '#ffffff',
                      fontSize: 18,
                      fontWeight: '700',
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish'
                      ? 'Perfil del Miembro'
                      : 'Member Profile'}
                  </div>

                  <Link
                    to={`/borrowingacct/${that.state.socialOverlayData_contractAddress}`}
                    onClick={() => {
                      that.setState({
                        socialOverlay: false,
                        commentViewerMediaFileName: null,
                      })
                    }}
                    style={{
                      width: 38,
                      height: 38,
                      borderRadius: 19,
                      backgroundColor: 'rgba(255, 255, 255, 0.18)',
                      color: '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textDecoration: 'none',
                    }}
                  >
                    <i
                      className="arrow right icon"
                      style={{ margin: 0, fontSize: 17 }}
                    />
                  </Link>
                </div>

                {/* PROFILE */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 24,
                    padding: '26px 30px',
                    borderBottom:
                      that.state.mode_light_dark == 'light'
                        ? '1px solid rgba(0,0,0,0.10)'
                        : '1px solid rgba(255,255,255,0.10)',
                  }}
                >
                  <img
                    src={that.state.socialOverlayData_imageURI}
                    alt=""
                    style={{
                      width: 115,
                      height: 115,
                      minWidth: 115,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid rgba(0, 158, 129, 1)',
                    }}
                  />

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                      style={{
                        color: 'rgba(0, 158, 129, 1)',
                        fontSize: 27,
                        fontWeight: '700',
                        overflowWrap: 'anywhere',
                      }}
                    >
                      {String(
                        that.state.socialOverlayData_displayName ||
                        that.state.socialOverlayData_username ||
                        ''
                      ).toUpperCase()}
                    </div>

                    <div
                      style={{
                        marginTop: 5,
                        fontSize: 17,
                        fontWeight: '600',
                        color:
                          that.state.mode_light_dark == 'light'
                            ? '#171717'
                            : '#ffffff',
                      }}
                    >
                      {String(
                        that.state.socialOverlayData_username || ''
                      ).toUpperCase()}
                    </div>

                    <div
                      style={{
                        marginTop: 4,
                        fontSize: 15,
                        color:
                          that.state.mode_light_dark == 'light'
                            ? '#555555'
                            : '#bbbbbb',
                      }}
                    >
                      {that.state.socialOverlayData_fullName}
                    </div>

                    <div
                      style={{
                        marginTop: 12,
                        fontSize: 15,
                        lineHeight: 1.5,
                        color:
                          that.state.mode_light_dark == 'light'
                            ? '#333333'
                            : '#dddddd',
                      }}
                    >
                      {String(
                        that.state.socialOverlayData_bioString || ''
                      ).substring(0, 200)}
                    </div>
                  </div>
                </div>

                {/* POSTS */}
                <div style={{ padding: '24px 30px 32px' }}>

                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: '700',
                      color: 'rgba(0, 158, 129, 1)',
                      marginBottom: 18,
                    }}
                  >
                    {that.state.selectedLanguage == 'spanish'
                      ? 'Publicaciones'
                      : 'Posts'}
                  </div>

                  {
                    that.state.mediaMapArray &&
                    that.state.mediaMapArray.length > 0
                    ?
                      that.state.mediaMapArray.map((listItemA, mediaIndex) => (

                        <div
                          key={listItemA.mediaFileName || mediaIndex}
                          style={{
                            width: '100%',
                            display: 'grid',
                            gridTemplateColumns:
                              'minmax(320px, 1fr) minmax(300px, 0.85fr)',
                            gap: 22,
                            padding: 18,
                            marginBottom: 24,
                            boxSizing: 'border-box',
                            borderRadius: 12,
                            backgroundColor:
                              that.state.mode_light_dark == 'light'
                                ? '#ffffff'
                                : '#2d2d2f',
                            border:
                              that.state.mode_light_dark == 'light'
                                ? '1px solid rgba(0,0,0,0.08)'
                                : '1px solid rgba(255,255,255,0.08)',
                          }}
                        >

                          {/* MEDIA */}
                          <div>
                            {
                              String(listItemA.mediaURI || '')
                                .toLowerCase()
                                .includes('mp4')
                              ?
                                <video
                                  controls
                                  style={{
                                    width: '100%',
                                    maxHeight: 560,
                                    borderRadius: 8,
                                    objectFit: 'contain',
                                    backgroundColor: '#000000',
                                  }}
                                >
                                  <source
                                    src={listItemA.mediaURI}
                                    type="video/mp4"
                                  />
                                </video>
                              :
                                <img
                                  src={listItemA.mediaURI}
                                  alt=""
                                  style={{
                                    width: '100%',
                                    maxHeight: 560,
                                    borderRadius: 8,
                                    objectFit: 'contain',
                                    display: 'block',
                                    backgroundColor: '#000000',
                                  }}
                                />
                            }

                            {/* POST ACTIONS */}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                marginTop: 12,
                              }}
                            >
                              {/* LIKE PHOTO */}
                              <Button
                                onClick={() => {
                                  let likesArray = []

                                  API.put('api1169ba1e', '', {
                                    headers: {
                                      Authorization: `Bearer ${cognitoID}`
                                    },
                                    body: {
                                      category: 'db',
                                      tableName: 'mediaUploads',
                                      primaryKey: String(listItemA.mediaFileName),
                                      requestOperation: 'get',
                                    }
                                  }).then((mediaData) => {

                                    if (
                                      mediaData.hasOwnProperty('Item') &&
                                      mediaData.Item.hasOwnProperty('likesArray')
                                    ) {
                                      likesArray = [...mediaData.Item.likesArray]
                                    }

                                    const username = currentUser.toLowerCase()

                                    if (likesArray.includes(username)) {
                                      likesArray.splice(
                                        likesArray.indexOf(username),
                                        1
                                      )
                                    } else {
                                      likesArray.push(username)
                                    }

                                    API.put('api1169ba1e', '', {
                                      headers: {
                                        Authorization: `Bearer ${cognitoID}`
                                      },
                                      body: {
                                        category: 'db',
                                        tableName: 'mediaUploads',
                                        primaryKey: String(listItemA.mediaFileName),
                                        requestOperation: 'update',
                                        updateExpression:
                                          'SET likesArray = :likesArray',
                                        expressionAttributeValues: {
                                          ':likesArray': likesArray,
                                        }
                                      }
                                    }).then(() => {
                                      listItemA.likesArray = likesArray

                                      that.setState({
                                        mediaMapArray: [
                                          ...that.state.mediaMapArray
                                        ]
                                      })
                                    })
                                  })
                                }}
                                style={{
                                  backgroundColor: 'transparent',
                                  boxShadow: 'none',
                                  padding: 8,
                                }}
                              >
                                <i
                                  className={
                                    listItemA.likesArray &&
                                    listItemA.likesArray.includes(
                                      currentUser.toLowerCase()
                                    )
                                    ? 'heart icon'
                                    : 'heart outline icon'
                                  }
                                  style={{
                                    color: 'rgba(204, 12, 12, 1)',
                                    fontSize: 25,
                                    margin: 0,
                                  }}
                                />

                                <span
                                  style={{
                                    marginLeft: 6,
                                    color: 'rgba(204, 12, 12, 1)',
                                    fontWeight: '600',
                                  }}
                                >
                                  {
                                    listItemA.likesArray
                                      ? listItemA.likesArray.length
                                      : 0
                                  }
                                </span>
                              </Button>

                              {/* NEW COMMENT */}
                              <Button
                                onClick={() => {
                                  that.setState({
                                    commentReplyID: null,
                                    newCommentStringInput: '',
                                    commentInitMediaFileName:
                                      listItemA.mediaFileName,
                                  })
                                }}
                                style={{
                                  backgroundColor: 'transparent',
                                  boxShadow: 'none',
                                  padding: 8,
                                }}
                              >
                                <i
                                  className="pen square icon"
                                  style={{
                                    color: 'rgba(0, 158, 129, 1)',
                                    fontSize: 24,
                                    margin: 0,
                                  }}
                                />

                                <span
                                  style={{
                                    marginLeft: 6,
                                    color: 'rgba(0, 158, 129, 1)',
                                    fontWeight: '600',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish'
                                    ? 'Comentar'
                                    : 'Comment'}
                                </span>
                              </Button>
                            </div>
                          </div>

                          {/* CAPTION + COMMENTS */}
                          <div
                            style={{
                              minWidth: 0,
                              maxHeight: 560,
                              overflowY: 'auto',
                              paddingRight: 8,
                            }}
                          >

                            {/* CAPTION */}
                            <div
                              style={{
                                paddingBottom: 14,
                                marginBottom: 14,
                                borderBottom:
                                  that.state.mode_light_dark == 'light'
                                    ? '1px solid rgba(0,0,0,0.08)'
                                    : '1px solid rgba(255,255,255,0.08)',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 15,
                                  fontWeight: '700',
                                  color:
                                    that.state.mode_light_dark == 'light'
                                      ? '#171717'
                                      : '#ffffff',
                                }}
                              >
                                {String(
                                  listItemA.publisherUsername || ''
                                ).toUpperCase()}
                              </div>

                              <div
                                style={{
                                  marginTop: 7,
                                  fontSize: 14,
                                  lineHeight: 1.5,
                                  color:
                                    that.state.mode_light_dark == 'light'
                                      ? '#333333'
                                      : '#dddddd',
                                  overflowWrap: 'anywhere',
                                }}
                              >
                                {listItemA.mediaItemCaption}
                              </div>
                            </div>

                            {/* ADD COMMENT INPUT */}
                            {
                              that.state.commentInitMediaFileName ==
                              listItemA.mediaFileName
                              ?
                                <div
                                  style={{
                                    marginBottom: 18,
                                    padding: 12,
                                    borderRadius: 8,
                                    backgroundColor:
                                      that.state.mode_light_dark == 'light'
                                        ? '#f4f4f4'
                                        : '#38383a',
                                  }}
                                >
                                  <input
                                    autoComplete="off"
                                    type="text"
                                    value={
                                      that.state.newCommentStringInput || ''
                                    }
                                    maxLength="275"
                                    onChange={(event) => {
                                      that.setState({
                                        newCommentStringInput:
                                          event.target.value
                                      })
                                    }}
                                    placeholder={
                                      that.state.selectedLanguage == 'spanish'
                                        ? 'Escribe un comentario'
                                        : 'Write a comment'
                                    }
                                    style={{
                                      width: '100%',
                                      boxSizing: 'border-box',
                                      padding: '11px 12px',
                                      borderRadius: 6,
                                      border:
                                        '1px solid rgba(0,158,129,0.35)',
                                      outline: 'none',
                                      color:
                                        that.state.mode_light_dark == 'light'
                                          ? '#171717'
                                          : '#ffffff',
                                      backgroundColor:
                                        that.state.mode_light_dark == 'light'
                                          ? '#ffffff'
                                          : '#232324',
                                    }}
                                  />

                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                      gap: 8,
                                      marginTop: 9,
                                    }}
                                  >
                                    <Button
                                      onClick={() => {
                                        that.setState({
                                          newCommentStringInput: null,
                                          commentInitMediaFileName: null,
                                        })
                                      }}
                                    >
                                      {that.state.selectedLanguage == 'spanish'
                                        ? 'Cancelar'
                                        : 'Cancel'}
                                    </Button>

                                    <Button
                                      onClick={() => {

                                        if (
                                          !that.state.newCommentStringInput ||
                                          String(
                                            that.state.newCommentStringInput
                                          ).trim().length < 2
                                        ) {
                                          return
                                        }

                                        var randomString1 =
                                          String(Date.now()) +
                                          Math.random()
                                            .toString(36)
                                            .substring(2, 15) +
                                          Math.random()
                                            .toString(36)
                                            .substring(2, 15)

                                        randomString1 =
                                          String(currentUser).concat(
                                            randomString1.substring(0, 18)
                                          )

                                        const newComment = {
                                          sender: currentUser.toLowerCase(),
                                          sentTimestamp: Date.now(),
                                          messageText: String(
                                            that.state.newCommentStringInput
                                          ),
                                          messageID: randomString1,
                                          subReplyCommentsArray: [],
                                          commentsReplyMapArray: [],
                                          likesArray: [],
                                          profilePictureURI:
                                            that.state.currentUserProfilePicture ||
                                            null,
                                        }

                                        API.put('api1169ba1e', '', {
                                          headers: {
                                            Authorization:
                                              `Bearer ${cognitoID}`
                                          },
                                          body: {
                                            category: 'db',
                                            tableName: 'mediaUploads',
                                            primaryKey:
                                              String(listItemA.mediaFileName),
                                            requestOperation: 'update',
                                            updateExpression:
                                              'SET commentsMapArray = list_append(commentsMapArray, :newCommentMap)',
                                            expressionAttributeValues: {
                                              ':newCommentMap': [
                                                {
                                                  sender:
                                                    currentUser.toLowerCase(),
                                                  sentTimestamp: Date.now(),
                                                  messageText:
                                                    String(
                                                      that.state
                                                        .newCommentStringInput
                                                    ),
                                                  messageID: randomString1,
                                                  subReplyCommentsArray: [],
                                                  likesArray: [],
                                                }
                                              ]
                                            }
                                          }
                                        }).then(() => {

                                          API.put('api1169ba1e', '', {
                                            headers: {
                                              Authorization:
                                                `Bearer ${cognitoID}`
                                            },
                                            body: {
                                              category: 'db',
                                              tableName:
                                                'mediaUploadComments',
                                              primaryKey: randomString1,
                                              requestOperation: 'update',
                                              updateExpression:
                                                'SET commentsReplyMapArray = :commentsReplyMapArray, isReplyBool = :isReplyBool, likesArray = :likesArray',
                                              expressionAttributeValues: {
                                                ':commentsReplyMapArray': [],
                                                ':isReplyBool': false,
                                                ':likesArray': [],
                                              }
                                            }
                                          }).then(() => {

                                            if (!listItemA.commentsMapArray) {
                                              listItemA.commentsMapArray = []
                                            }

                                            listItemA.commentsMapArray.push(
                                              newComment
                                            )

                                            that.setState({
                                              newCommentStringInput: null,
                                              commentInitMediaFileName: null,
                                              mediaMapArray: [
                                                ...that.state.mediaMapArray
                                              ]
                                            })
                                          })
                                        })
                                      }}
                                      style={{
                                        backgroundColor:
                                          'rgba(0, 158, 129, 1)',
                                        color: '#ffffff',
                                      }}
                                    >
                                      {that.state.selectedLanguage == 'spanish'
                                        ? 'Comentar'
                                        : 'Comment'}
                                    </Button>
                                  </div>
                                </div>
                              :
                                null
                            }

                            <div
                              style={{
                                fontSize: 14,
                                fontWeight: '700',
                                color: 'rgba(0, 158, 129, 1)',
                                marginBottom: 10,
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish'
                                ? 'Comentarios'
                                : 'Comments'}
                            </div>

                            {/* COMMENTS */}
                            {
                              listItemA.commentsMapArray &&
                              listItemA.commentsMapArray.length > 0
                              ?
                                listItemA.commentsMapArray.map(
                                  (listItemB, commentIndex) => (

                                    <div
                                      key={
                                        listItemB.messageID ||
                                        commentIndex
                                      }
                                      style={{
                                        display: 'flex',
                                        gap: 10,
                                        marginBottom: 16,
                                      }}
                                    >
                                      {
                                        listItemB.profilePictureURI
                                        ?
                                          <img
                                            src={
                                              listItemB.profilePictureURI
                                            }
                                            alt=""
                                            style={{
                                              width: 38,
                                              height: 38,
                                              minWidth: 38,
                                              borderRadius: 19,
                                              objectFit: 'cover',
                                            }}
                                          />
                                        :
                                          <div
                                            style={{
                                              width: 38,
                                              height: 38,
                                              minWidth: 38,
                                              borderRadius: 19,
                                              backgroundColor:
                                                'rgba(0,158,129,0.18)',
                                            }}
                                          />
                                      }

                                      <div
                                        style={{
                                          flex: 1,
                                          minWidth: 0,
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontSize: 13,
                                            fontWeight: '700',
                                            color:
                                              that.state.mode_light_dark ==
                                              'light'
                                                ? '#171717'
                                                : '#ffffff',
                                          }}
                                        >
                                          {String(
                                            listItemB.sender || ''
                                          ).toUpperCase()}
                                        </div>

                                        <div
                                          style={{
                                            marginTop: 3,
                                            fontSize: 13,
                                            lineHeight: 1.45,
                                            color:
                                              that.state.mode_light_dark ==
                                              'light'
                                                ? '#333333'
                                                : '#dddddd',
                                            overflowWrap: 'anywhere',
                                          }}
                                        >
                                          {listItemB.messageText}
                                        </div>

                                        {/* COMMENT ACTIONS */}
                                        <div
                                          style={{
                                            display: 'flex',
                                            gap: 12,
                                            alignItems: 'center',
                                            marginTop: 6,
                                          }}
                                        >
                                          {/* LIKE COMMENT */}
                                          <button
                                            onClick={() => {

                                              API.put(
                                                'api1169ba1e',
                                                '',
                                                {
                                                  headers: {
                                                    Authorization:
                                                      `Bearer ${cognitoID}`
                                                  },
                                                  body: {
                                                    category: 'db',
                                                    tableName:
                                                      'mediaUploadComments',
                                                    primaryKey:
                                                      String(
                                                        listItemB.messageID
                                                      ),
                                                    requestOperation: 'get',
                                                  }
                                                }
                                              ).then((commentData) => {

                                                let likesArray =
                                                  commentData.Item &&
                                                  commentData.Item.likesArray
                                                  ? [
                                                      ...commentData.Item
                                                        .likesArray
                                                    ]
                                                  : []

                                                const username =
                                                  currentUser.toLowerCase()

                                                if (
                                                  likesArray.includes(username)
                                                ) {
                                                  likesArray.splice(
                                                    likesArray.indexOf(
                                                      username
                                                    ),
                                                    1
                                                  )
                                                } else {
                                                  likesArray.push(username)
                                                }

                                                API.put(
                                                  'api1169ba1e',
                                                  '',
                                                  {
                                                    headers: {
                                                      Authorization:
                                                        `Bearer ${cognitoID}`
                                                    },
                                                    body: {
                                                      category: 'db',
                                                      tableName:
                                                        'mediaUploadComments',
                                                      primaryKey:
                                                        String(
                                                          listItemB.messageID
                                                        ),
                                                      requestOperation:
                                                        'update',
                                                      updateExpression:
                                                        'SET likesArray = :likesArray',
                                                      expressionAttributeValues: {
                                                        ':likesArray':
                                                          likesArray
                                                      }
                                                    }
                                                  }
                                                ).then(() => {
                                                  listItemB.likesArray =
                                                    likesArray

                                                  that.setState({
                                                    mediaMapArray: [
                                                      ...that.state
                                                        .mediaMapArray
                                                    ]
                                                  })
                                                })
                                              })
                                            }}
                                            style={{
                                              border: 0,
                                              padding: 0,
                                              background: 'transparent',
                                              cursor: 'pointer',
                                              color:
                                                'rgba(204,12,12,1)',
                                              fontSize: 12,
                                              fontWeight: '600',
                                            }}
                                          >
                                            <i
                                              className={
                                                listItemB.likesArray &&
                                                listItemB.likesArray.includes(
                                                  currentUser.toLowerCase()
                                                )
                                                  ? 'heart icon'
                                                  : 'heart outline icon'
                                              }
                                            />

                                            {
                                              listItemB.likesArray
                                                ? listItemB.likesArray
                                                    .length
                                                : 0
                                            }
                                          </button>

                                          {/* REPLY */}
                                          <button
                                            onClick={() => {
                                              that.setState({
                                                newCommentStringInput: '',
                                                commentReplyID:
                                                  listItemB.messageID,
                                                commentInitMediaFileName:
                                                  null,
                                              })
                                            }}
                                            style={{
                                              border: 0,
                                              padding: 0,
                                              background: 'transparent',
                                              cursor: 'pointer',
                                              color:
                                                'rgba(0,158,129,1)',
                                              fontSize: 12,
                                              fontWeight: '600',
                                            }}
                                          >
                                            <i className="reply icon" />

                                            {that.state.selectedLanguage ==
                                            'spanish'
                                              ? 'Responder'
                                              : 'Reply'}
                                          </button>
                                        </div>

                                        {/* REPLY INPUT */}
                                        {
                                          that.state.commentReplyID ==
                                          listItemB.messageID
                                          ?
                                            <div
                                              style={{
                                                marginTop: 10,
                                              }}
                                            >
                                              <input
                                                autoComplete="off"
                                                type="text"
                                                value={
                                                  that.state
                                                    .newCommentStringInput ||
                                                  ''
                                                }
                                                maxLength="275"
                                                onChange={(event) => {
                                                  that.setState({
                                                    newCommentStringInput:
                                                      event.target.value
                                                  })
                                                }}
                                                placeholder={
                                                  that.state
                                                    .selectedLanguage ==
                                                  'spanish'
                                                    ? 'Escribe una respuesta'
                                                    : 'Write a reply'
                                                }
                                                style={{
                                                  width: '100%',
                                                  boxSizing: 'border-box',
                                                  padding: '9px 10px',
                                                  borderRadius: 6,
                                                  border:
                                                    '1px solid rgba(0,158,129,0.35)',
                                                  backgroundColor:
                                                    that.state
                                                      .mode_light_dark ==
                                                    'light'
                                                      ? '#ffffff'
                                                      : '#232324',
                                                  color:
                                                    that.state
                                                      .mode_light_dark ==
                                                    'light'
                                                      ? '#171717'
                                                      : '#ffffff',
                                                }}
                                              />

                                              <div
                                                style={{
                                                  display: 'flex',
                                                  justifyContent:
                                                    'flex-end',
                                                  gap: 7,
                                                  marginTop: 7,
                                                }}
                                              >
                                                <Button
                                                  size="mini"
                                                  onClick={() => {
                                                    that.setState({
                                                      newCommentStringInput:
                                                        null,
                                                      commentReplyID: null,
                                                    })
                                                  }}
                                                >
                                                  {that.state
                                                    .selectedLanguage ==
                                                  'spanish'
                                                    ? 'Cancelar'
                                                    : 'Cancel'}
                                                </Button>

                                                <Button
                                                  size="mini"
                                                  onClick={() => {

                                                    if (
                                                      !that.state
                                                        .newCommentStringInput ||
                                                      String(
                                                        that.state
                                                          .newCommentStringInput
                                                      ).trim().length < 2
                                                    ) {
                                                      return
                                                    }

                                                    var randomString1 =
                                                      String(Date.now()) +
                                                      Math.random()
                                                        .toString(36)
                                                        .substring(2, 15) +
                                                      Math.random()
                                                        .toString(36)
                                                        .substring(2, 15)

                                                    randomString1 =
                                                      String(
                                                        currentUser
                                                      ).concat(
                                                        randomString1.substring(
                                                          0,
                                                          18
                                                        )
                                                      )

                                                    const newReply = {
                                                      sender:
                                                        currentUser.toLowerCase(),
                                                      sentTimestamp:
                                                        Date.now(),
                                                      messageText:
                                                        String(
                                                          that.state
                                                            .newCommentStringInput
                                                        ),
                                                      messageID:
                                                        randomString1,
                                                      rootMessageID:
                                                        listItemB.messageID,
                                                      likesArray: [],
                                                      profilePictureURI:
                                                        that.state
                                                          .currentUserProfilePicture ||
                                                        null,
                                                    }

                                                    API.put(
                                                      'api1169ba1e',
                                                      '',
                                                      {
                                                        headers: {
                                                          Authorization:
                                                            `Bearer ${cognitoID}`
                                                        },
                                                        body: {
                                                          category: 'db',
                                                          tableName:
                                                            'mediaUploadComments',
                                                          primaryKey:
                                                            listItemB.messageID,
                                                          requestOperation:
                                                            'update',
                                                          updateExpression:
                                                            'SET commentsReplyMapArray = list_append(commentsReplyMapArray, :newCommentReplyMap)',
                                                          expressionAttributeValues: {
                                                            ':newCommentReplyMap':
                                                              [
                                                                {
                                                                  sender:
                                                                    currentUser.toLowerCase(),
                                                                  sentTimestamp:
                                                                    Date.now(),
                                                                  messageText:
                                                                    String(
                                                                      that
                                                                        .state
                                                                        .newCommentStringInput
                                                                    ),
                                                                  messageID:
                                                                    randomString1,
                                                                  rootMessageID:
                                                                    listItemB.messageID,
                                                                  likesArray:
                                                                    [],
                                                                }
                                                              ]
                                                          }
                                                        }
                                                      }
                                                    ).then(() => {

                                                      if (
                                                        !listItemB
                                                          .commentsReplyMapArray
                                                      ) {
                                                        listItemB.commentsReplyMapArray =
                                                          []
                                                      }

                                                      listItemB.commentsReplyMapArray.push(
                                                        newReply
                                                      )

                                                      that.setState({
                                                        newCommentStringInput:
                                                          null,
                                                        commentReplyID: null,
                                                        mediaMapArray: [
                                                          ...that.state
                                                            .mediaMapArray
                                                        ]
                                                      })
                                                    })
                                                  }}
                                                  style={{
                                                    backgroundColor:
                                                      'rgba(0,158,129,1)',
                                                    color: '#ffffff',
                                                  }}
                                                >
                                                  {that.state
                                                    .selectedLanguage ==
                                                  'spanish'
                                                    ? 'Responder'
                                                    : 'Reply'}
                                                </Button>
                                              </div>
                                            </div>
                                          :
                                            null
                                        }

                                        {/* REPLIES */}
                                        {
                                          listItemB.commentsReplyMapArray &&
                                          listItemB.commentsReplyMapArray
                                            .length > 0
                                          ?
                                            <div
                                              style={{
                                                marginTop: 12,
                                                marginLeft: 12,
                                                paddingLeft: 12,
                                                borderLeft:
                                                  '2px solid rgba(0,158,129,0.30)',
                                              }}
                                            >
                                              {
                                                listItemB.commentsReplyMapArray.map(
                                                  (
                                                    listItemE,
                                                    replyIndex
                                                  ) => (

                                                    <div
                                                      key={
                                                        listItemE.messageID ||
                                                        replyIndex
                                                      }
                                                      style={{
                                                        display: 'flex',
                                                        gap: 8,
                                                        marginBottom: 10,
                                                      }}
                                                    >
                                                      {
                                                        listItemE.profilePictureURI
                                                        ?
                                                          <img
                                                            src={
                                                              listItemE.profilePictureURI
                                                            }
                                                            alt=""
                                                            style={{
                                                              width: 30,
                                                              height: 30,
                                                              minWidth: 30,
                                                              borderRadius: 15,
                                                              objectFit:
                                                                'cover',
                                                            }}
                                                          />
                                                        :
                                                          <div
                                                            style={{
                                                              width: 30,
                                                              height: 30,
                                                              minWidth: 30,
                                                              borderRadius: 15,
                                                              backgroundColor:
                                                                'rgba(0,158,129,0.18)',
                                                            }}
                                                          />
                                                      }

                                                      <div
                                                        style={{
                                                          flex: 1,
                                                          minWidth: 0,
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            fontSize: 12,
                                                            fontWeight:
                                                              '700',
                                                            color:
                                                              that.state
                                                                .mode_light_dark ==
                                                              'light'
                                                                ? '#171717'
                                                                : '#ffffff',
                                                          }}
                                                        >
                                                          {String(
                                                            listItemE.sender ||
                                                            ''
                                                          ).toUpperCase()}
                                                        </div>

                                                        <div
                                                          style={{
                                                            marginTop: 2,
                                                            fontSize: 12,
                                                            lineHeight: 1.4,
                                                            color:
                                                              that.state
                                                                .mode_light_dark ==
                                                              'light'
                                                                ? '#444444'
                                                                : '#cccccc',
                                                          }}
                                                        >
                                                          {
                                                            listItemE.messageText
                                                          }
                                                        </div>

                                                        {/* LIKE REPLY */}
                                                        <button
                                                          onClick={() => {

                                                            API.put(
                                                              'api1169ba1e',
                                                              '',
                                                              {
                                                                headers: {
                                                                  Authorization:
                                                                    `Bearer ${cognitoID}`
                                                                },
                                                                body: {
                                                                  category:
                                                                    'db',
                                                                  tableName:
                                                                    'mediaUploadComments',
                                                                  primaryKey:
                                                                    String(
                                                                      listItemE.rootMessageID
                                                                    ),
                                                                  requestOperation:
                                                                    'get',
                                                                }
                                                              }
                                                            ).then(
                                                              (
                                                                commentData
                                                              ) => {

                                                                let replies =
                                                                  commentData
                                                                    .Item &&
                                                                  commentData
                                                                    .Item
                                                                    .commentsReplyMapArray
                                                                  ? [
                                                                      ...commentData
                                                                        .Item
                                                                        .commentsReplyMapArray
                                                                    ]
                                                                  : []

                                                                const targetIndex =
                                                                  replies.findIndex(
                                                                    (
                                                                      reply
                                                                    ) =>
                                                                      reply.messageID ==
                                                                      listItemE.messageID
                                                                  )

                                                                if (
                                                                  targetIndex <
                                                                  0
                                                                ) {
                                                                  return
                                                                }

                                                                let likesArray =
                                                                  replies[
                                                                    targetIndex
                                                                  ]
                                                                    .likesArray
                                                                  ? [
                                                                      ...replies[
                                                                        targetIndex
                                                                      ]
                                                                        .likesArray
                                                                    ]
                                                                  : []

                                                                const username =
                                                                  currentUser.toLowerCase()

                                                                if (
                                                                  likesArray.includes(
                                                                    username
                                                                  )
                                                                ) {
                                                                  likesArray.splice(
                                                                    likesArray.indexOf(
                                                                      username
                                                                    ),
                                                                    1
                                                                  )
                                                                } else {
                                                                  likesArray.push(
                                                                    username
                                                                  )
                                                                }

                                                                replies[
                                                                  targetIndex
                                                                ].likesArray =
                                                                  likesArray

                                                                API.put(
                                                                  'api1169ba1e',
                                                                  '',
                                                                  {
                                                                    headers:
                                                                      {
                                                                        Authorization:
                                                                          `Bearer ${cognitoID}`
                                                                      },
                                                                    body: {
                                                                      category:
                                                                        'db',
                                                                      tableName:
                                                                        'mediaUploadComments',
                                                                      primaryKey:
                                                                        String(
                                                                          listItemE.rootMessageID
                                                                        ),
                                                                      requestOperation:
                                                                        'update',
                                                                      updateExpression:
                                                                        'SET commentsReplyMapArray = :commentsReplyMapArray',
                                                                      expressionAttributeValues:
                                                                        {
                                                                          ':commentsReplyMapArray':
                                                                            replies
                                                                        }
                                                                    }
                                                                  }
                                                                ).then(
                                                                  () => {
                                                                    listItemE.likesArray =
                                                                      likesArray

                                                                    that.setState(
                                                                      {
                                                                        mediaMapArray:
                                                                          [
                                                                            ...that
                                                                              .state
                                                                              .mediaMapArray
                                                                          ]
                                                                      }
                                                                    )
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          }}
                                                          style={{
                                                            border: 0,
                                                            background:
                                                              'transparent',
                                                            padding: 0,
                                                            marginTop: 4,
                                                            cursor:
                                                              'pointer',
                                                            color:
                                                              'rgba(204,12,12,1)',
                                                            fontSize: 11,
                                                          }}
                                                        >
                                                          <i
                                                            className={
                                                              listItemE.likesArray &&
                                                              listItemE.likesArray.includes(
                                                                currentUser.toLowerCase()
                                                              )
                                                                ? 'heart icon'
                                                                : 'heart outline icon'
                                                            }
                                                          />

                                                          {
                                                            listItemE.likesArray
                                                              ? listItemE
                                                                  .likesArray
                                                                  .length
                                                              : 0
                                                          }
                                                        </button>
                                                      </div>
                                                    </div>

                                                  )
                                                )
                                              }
                                            </div>
                                          :
                                            null
                                        }

                                      </div>
                                    </div>

                                  )
                                )
                              :
                                <div
                                  style={{
                                    padding: '15px 0',
                                    fontSize: 13,
                                    color:
                                      that.state.mode_light_dark ==
                                      'light'
                                        ? '#777777'
                                        : '#999999',
                                  }}
                                >
                                  {that.state.selectedLanguage ==
                                  'spanish'
                                    ? 'Aún no hay comentarios.'
                                    : 'No comments yet.'}
                                </div>
                            }

                          </div>
                        </div>

                      ))
                    :
                      <div
                        style={{
                          padding: '40px 20px',
                          textAlign: 'center',
                          color:
                            that.state.mode_light_dark == 'light'
                              ? '#666666'
                              : '#aaaaaa',
                        }}
                      >
                        {that.state.selectedLanguage == 'spanish'
                          ? 'No hay publicaciones todavía.'
                          : 'No posts yet.'}
                      </div>
                  }
                </div>
              </div>
            </Modal>

                      

            <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
              open={that.state.generalNoticeOverlay}
              // open={true}
              style={{
                width: '29vw',
                height: '25vh',
              }}
              // trigger={<Button>Show Modal</Button>}
            >
              <Modal.Header
                style={{
                  paddingLeft: '7vh',
                }}
              >
                
                The Blender Platform
              </Modal.Header>
                
                
              <Modal.Content image>
                <Modal.Description>
                  <Header
                    style={{
                      left: '1vw',
                      marginRight: '1vw',
                      position: 'absolute',
                    }}
                  >{`${that.state.generalNoticeText}`}</Header>
                  <Button
                    content="Okay"
                    labelPosition='right'
                    icon='checkmark'
                    onClick={() => {
                      that.setState({
                        generalNoticeOverlay: false,
                      })
                    }}
                    positive
                    style={{
                      backgroundColor: 'rgba(0, 158, 129, 1)',
                      position: 'absolute',
                      bottom: 21,
                      width: '7vw',
                      left: '11vw',
                    }}
                  />
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>


            <div className="tbp-platform__sidebar" style={{
              // borderRadius: 10,
              justifyContent: 'center',
              alignItems: 'center',
              width: '13vw',
              height: '100vh',
              margin: 0,
              left: 0,
              position: 'absolute',
              borderRightStyle: 'solid',
              borderWidth: 0.1,
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
            }}>
              <Button
                onClick={() => {
                  that.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/home',
                    },
                  })
                }}
                style={{
                  position: 'relative',
                  left: '2vw',
                  top: '1vw',
                  height: '5vw',
                  width: '5vw',
                  marginBottom: '2vh',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'rgba(0, 0, 0, 0)',
                }}
              >
                <img 
                  // className="logoImage" 
                  src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                  style={{
                    height: '4vw',
                    width: '4vw',
                    position: 'absolute',
                    top: 7, 
                    left: 3, 
                    right: 0,
                    borderRadius: 7,
                    borderStyle: 'solid',
                    borderWidth: 0.1,
                    borderColor: 'rgba(177, 177, 177, 0.1)',
                  }}
                />
              </Button>
              
              


              <List>
                <ListItem
                  style={{
                    marginBottom: 10,

                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/home',
                        },
                      })
                    }}
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="home icon"/>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Activos'
                          :
                        'Accounts'
                      }
                    </p>
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    // onClick={() => {
                    //   that.setState({
                    //     navigationDestinationObject: {
                    //         navigationRoute: '/browser',
                    //     },
                    //   })
                    // }}
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                    
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="search icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Buscar'
                          :
                        'Browse'
                      }
                    </p>
                    
                  </button>
                </ListItem>

                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/newborrowingacct',
                        },
                      })
                    }}
                    className="ui huge teal button"
                      
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="newspaper icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Tomar Prestamo'
                          :
                        'Borrow Funds'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/membertransactions',
                        },
                      })
                    }}
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="wait icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Transacciones'
                          :
                        'Transactions'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/SubscriptionPlan',
                        },
                      })
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="star icon"></i>
                      &nbsp;  
                      {'Blender Pro Plus'}
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
                      win.focus();
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="book icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Condiciones'
                          :
                        'Terms of Use'
                      }
                    </p>
                    
                  </button>
                </ListItem>
                <ListItem
                  style={{
                    marginBottom: 10,
                    marginLeft: 25
                  }}
                >
                  <button 
                    style={{
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => {
                      var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
                      win.focus();
                    }}
                    className="ui huge teal button"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        textAlign: 'left'
                      }}
                    >
                      <i className="book icon"></i>
                      &nbsp;
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Privacidad'
                          :
                        'Privacy Policy'
                      }
                    </p>
                    
                  </button>
                </ListItem>
              </List>



              <button 
                
                style={{
                  position: 'fixed',
                  bottom: 20,
                  marginBottom: 10,
                  marginLeft: 25,
                  borderRadius: 20,
                  backgroundColor: 'rgba(0, 158, 129, 0)',
                  borderWidth: 2,
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: 15,
                }}
                onClick={() => { 
                  trackPageRequest(Auth.signOut())
                  that.setState({
                    navigationDestinationObject: {
                        navigationRoute: '/welcome',
                    },
                  }) 
                }}
                className="ui medium teal button"
              >
                <p
                  style={{
                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                  }}
                >
                  <i className="sign out icon"/>
                  {that.state.selectedLanguage == 'spanish' ? 
                    'Desconectar'
                      :
                    'Sign Out'
                  }
                </p>
              </button>
            </div>

            <div className="tbp-platform__workspace" style={{
              // backgroundColor: 'blue',
              // borderRadius: 10, 
              justifyContent: 'center',
              alignItems: 'center',
              width: '87vw',
              height: '100vh',
              margin: 0,
              flexDirection: 'column',
              // borderStyle: 'none',
              borderWidth: 0,    
              position: 'absolute',
              left: '13vw',
              top: '0vh',
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              // border: 'none',   
              // borderColor: 'rgba(177, 177, 177, 0)',
            }}>
            
              <div className="tbp-platform__topbar" style={{
                // backgroundColor: 'rgba(0, 158, 129, 0)',
                // borderRadius: 10,
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '87vw',
                height: '7vh',
                paddingLeft: '3vw',
                margin: 0,
                display: 'flex',
                flexDirection: 'row',
                paddingRight: '10vw',
                borderBottomStyle: 'solid',
                borderWidth: 0.1,
                borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
              }}>
                <p 
                  style={{ 
                    textAlign: 'left',
                    textAlignVertical: 'center',
                    fontSize: 23, 
                    fontWeight: '600', 
                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                    marginTop: 30, 
                    width: '25vw',
                    marginBottom: 30,
                    marginRight: 25,
                    // textUnderlineOffset: 3, 
                    // textDecorationLine: 'underline', 
                    // textDecorationColor: 'rgba(255, 255, 255, 1)',
                  }}
                >
                    <span className="tbp-platform__eyebrow">THE BLENDER PLATFORM</span><span className="tbp-platform__title">{that.state.selectedLanguage === 'spanish' ? "Descubrir" : "Discover"}</span>  
                </p>


                <div className="tbp-browser-search" role="search" aria-label={that.state.selectedLanguage === 'spanish' ? 'Buscar cuentas' : 'Search accounts'}>
                  <div className="tbp-browser-search__input-row">
                    <i className="search icon tbp-browser-search__icon" aria-hidden="true" />
                    <input
                      className="tbp-browser-search__input"
                      type="text"
                      autoComplete="off"
                      spellCheck={false}
                      maxLength={25}
                      role="combobox"
                      aria-autocomplete="list"
                      aria-expanded={Boolean(that.state.showSearchDropDownMenuBool && browserSearchQuery.length >= 1)}
                      aria-controls="tbp-browser-search-options"
                      aria-activedescendant={that.state.searchSuggestionIndex >= 0 && browserSearchSuggestions[that.state.searchSuggestionIndex] ? `tbp-browser-result-${that.state.searchSuggestionIndex}` : undefined}
                      aria-label={that.state.selectedLanguage === 'spanish' ? 'Nombre de usuario' : 'Account username'}
                      placeholder={that.state.selectedLanguage === 'spanish' ? 'Buscar usuario…' : 'Search username…'}
                      value={that.state.search || ''}
                      onChange={(event) => {
                        that.setState({
                          search: event.target.value,
                          searchedContractsArray: [],
                          searchSubmitted: false,
                          searchLookupFailed: false,
                          showSearchDropDownMenuBool: Boolean(event.target.value.trim()),
                          activeSearchBorrowerAccountBool: true,
                          searchSuggestionIndex: -1,
                        });
                      }}
                      onFocus={() => {
                        if (String(that.state.search || '').trim()) {
                          that.setState({showSearchDropDownMenuBool: true});
                        }
                      }}
                      onBlur={() => that.setState({showSearchDropDownMenuBool: false, searchSuggestionIndex: -1})}
                      onKeyDown={(event) => {
                        if (event.key === 'Escape') {
                          that.setState({showSearchDropDownMenuBool: false, searchSuggestionIndex: -1});
                        } else if (event.key === 'ArrowDown' && browserSearchSuggestions.length) {
                          event.preventDefault();
                          that.setState({
                            showSearchDropDownMenuBool: true,
                            searchSuggestionIndex: Math.min(Number(that.state.searchSuggestionIndex ?? -1) + 1, browserSearchSuggestions.length - 1),
                          });
                        } else if (event.key === 'ArrowUp' && browserSearchSuggestions.length) {
                          event.preventDefault();
                          that.setState({
                            showSearchDropDownMenuBool: true,
                            searchSuggestionIndex: Math.max(Number(that.state.searchSuggestionIndex ?? 0) - 1, 0),
                          });
                        } else if (event.key === 'Enter') {
                          event.preventDefault();
                          if (that.state.searchActivityBool) return;
                          const match = browserSearchSuggestions[that.state.searchSuggestionIndex];
                          const searchedName = match ? match.name : String(that.state.search || '').trim();
                          if (searchedName.length >= 2) {
                            that.setState({
                              search: searchedName,
                              showSearchDropDownMenuBool: false,
                              searchSuggestionIndex: -1,
                              activeSearchBorrowerAccountBool: false,
                            }, () => that.performSearch());
                          }
                        }
                      }}
                    />
                    {that.state.search && (
                      <button
                        type="button"
                        className="tbp-browser-search__clear"
                        aria-label={that.state.selectedLanguage === 'spanish' ? 'Borrar búsqueda' : 'Clear search'}
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={() => {
                          that.setState({
                            search: '',
                            showSearchDropDownMenuBool: false,
                            searchSuggestionIndex: -1,
                            activeSearchBorrowerAccountBool: false,
                            searchedContractsArray: [],
                            searchResultContracts: [],
                            searchSubmitted: false,
                            searchLookupFailed: false,
                          });
                        }}
                      ><i className="times icon" aria-hidden="true" /></button>
                    )}
                    <button
                      type="button"
                      className="tbp-browser-search__go"
                      disabled={that.state.searchActivityBool || browserSearchQuery.length < 2}
                      aria-label={that.state.selectedLanguage === 'spanish' ? 'Buscar' : 'Search'}
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => {
                        if (String(that.state.search || '').trim().length >= 2) {
                          that.setState({showSearchDropDownMenuBool: false, searchSuggestionIndex: -1}, () => that.performSearch());
                        }
                      }}
                    >{that.state.searchActivityBool ? <ThreeDot size="small" color="#eafbf6" /> : <i className="arrow right icon" aria-hidden="true" />}</button>
                  </div>
                  {that.state.showSearchDropDownMenuBool && browserSearchQuery.length >= 1 && (
                    <div className="tbp-browser-search__menu" id="tbp-browser-search-options" role="listbox" aria-label={that.state.selectedLanguage === 'spanish' ? 'Usuarios sugeridos' : 'Suggested usernames'}>
                      <div className="tbp-browser-search__menu-title">{that.state.selectedLanguage === 'spanish' ? 'Usuarios' : 'Accounts'}</div>
                      {browserSearchSuggestions.length ? browserSearchSuggestions.map((suggestion, index) => (
                        <button
                          type="button"
                          key={suggestion.name}
                          id={`tbp-browser-result-${index}`}
                          role="option"
                          aria-selected={index === that.state.searchSuggestionIndex}
                          className={'tbp-browser-search__option' + (index === that.state.searchSuggestionIndex ? ' is-highlighted' : '')}
                          onMouseDown={(event) => event.preventDefault()}
                          onClick={() => {
                            that.setState({
                              search: suggestion.name,
                              showSearchDropDownMenuBool: false,
                              searchSuggestionIndex: -1,
                              activeSearchBorrowerAccountBool: false,
                            }, () => that.performSearch());
                          }}
                        >
                          <i className="user circle outline icon" aria-hidden="true" />
                          <span>{suggestion.name.toUpperCase()}</span>
                          <i className="arrow right icon" aria-hidden="true" />
                        </button>
                      )) : (
                        <p className="tbp-browser-search__empty">{that.state.selectedLanguage === 'spanish' ? 'No hay coincidencias' : 'No matching usernames'}</p>
                      )}
                    </div>
                  )}
                </div>

                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'absolute',
                    right: 0,
                    padding: 10,
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingRight: 25,
                    borderRadius: 17
                  }}
                >
                  <Button
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/accountmanagement',
                        },
                      })
                    }}
                    style={{
                      borderBottomLeftRadius: 18,
                      borderBottomRightRadius: 5,
                      borderTopLeftRadius: 18,
                      borderTopRightRadius: 5,
                      height: '40px',
                      borderWidth: 2,
                      marginLeft: 25,
                      marginRight: 10,
                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(35, 35, 35, 1)', 
                      borderColor: 'rgba(224, 225, 226, 0)',
                      borderStyle: 'solid', 
                      justifyContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      flexDirection: 'row',
                      transitionDuration: '0.4s',
                      cursor: 'pointer',
                      padding: 0,
                    }}
                  >
                    <img 
                      className="header_profileImage" 
                      width="35" 
                      height="35" 
                      src={that.state.currentUserProfilePicture}
                    />

                    <p 
                      style={{ 
                        textAlign: 'right',
                        textAlignVertical: 'center',
                        fontSize: 16, 
                        fontWeight: '600', 
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                        marginLeft: 12, 
                        marginRight: 15,
                        marginTop: 5,
                        // textUnderlineOffset: 3, 
                        // textDecorationLine: 'underline', 
                        // textDecorationColor: 'rgba(255, 255, 255, 1)',
                      }}
                    >
                        {String(that.state.currentUser).toUpperCase()}
                    </p>
                  </Button>
                </div>
              



                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    position: 'absolute',
                    right: 200,
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 17,
                    backgroundColor: 'rgba(35, 35, 35, 0)',
                    borderRadius: 17,
                    width: '5vw',
                    height: '7vh', 
                  }}
                >


                  <button
                    style={{
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '2.5vw',
                      height: '7vh', 
                      paddingTop: '2.5vh',
                      paddingBottom: '1vh',
                      backgroundColor: 'rgba(35, 35, 35, 0)',
                      borderStyle: 'none',
                    }}
                    onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}
                  >
                    <p style={{ 
                      justifyContent: 'center',
                      textAlign: 'center',
                      textAlignVertical: 'center',
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                      fontWeight: '600',
                    }}>
                      <p style={{ 
                        justifyContent: 'center',
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                        fontWeight: '600',
                      }}>
                        <i
                          style={{
                            fontSize: that.state.mode_light_dark == 'dark' ? 34 : 31, 
                            marginBottom: 5, 
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            marginLeft: 5,
                          }}
                          className={that.state.mode_light_dark == 'dark' ? "sun icon" :"moon icon"}
                        />
                      </p>
                    </p>
                  </button>

                </div>   
      




              </div>

              <div className="tbp-platform__body" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                width: '87vw',
                height: '93vh',
                margin: 0,
                borderStyle: 'none',
                borderWidth: 0,
              }}>
                <div class="scrollNoScrollBar" style={{
                  // borderRadius: 10,
                  // backgroundColor: 'red',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '62vw',
                  position: 'fixed',
                  left: '13vw',
                  // top: 0, 
                  // bottom: 0, 
                  height: '93vh',

                  // here
                  
                  marginTop: 0,

                  marginBottom: 0,
                  marginRight: 0,
                  marginLeft: '0vw',
                  borderStyle: 'none',
                  borderWidth: 0,
                  scrollbarWidth: 'none',
                  scrollbarColor: 'rgba(177, 177, 177, 0)',
                  overflowY: 'auto',
                  
                  overflowX: 'hidden',

                }}>




                  {that.state.searchedContractsArray.length > 0 && (
                    <div className="tbp-browser-section tbp-browser-search-results">
                      <div className="tbp-browser-section-title">
                        <h2>{that.state.selectedLanguage === 'spanish' ? 'Resultados de Búsqueda' : 'Search Results'}</h2>
                      </div>
                      <div className="tbp-browser-list-container">
<div className="tbp-credit-header" 
                          style={{
                            display: 'flex',
                            width: '55vw',
                            height: '40px',
                            borderTopLeftRadius: '3px',
                            borderTopRightRadius: '3px',
                            paddingLeft: '2vw',
                            flexDirection: "row",
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                          }}
                        >
                          <div 
                            style={{
                              width: '17vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'PRESTATARIO'
                                :
                                'BORROWER'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '19vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'CRÉDITO DISPONIBLE'
                                :
                                'AVAILABLE CREDIT'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '9vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'PRESTADORES'
                                :
                                'LENDER(S)'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '9vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {'APR.'}
                            </p>
                          </div>
                        </div>
                                              <React.Fragment>
{that.state.searchedContractsArray.map(listItemC => (
                          
                              
                              <div className="tbp-credit-row tbp-credit-row--browse" 
                                style={{
                                  borderWidth: 0,
                                  display: 'flex',
                                  width: '55vw',
                                  height: '60px',
                                  paddingRight: 0,
                                  flexDirection: "row",
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                }}
                              >


                                <Button
                                  onClick={() => {
                                    that.setState({
                                      socialOverlay: true,
                                      socialOverlayData_username: listItemC.manager,
                                      socialOverlayData_displayName: listItemC.displayName,
                                      socialOverlayData_fullName: listItemC.fullName,
                                      socialOverlayData_imageURI: (
                                        listItemC.profilePicture_base64
                                        ?
                                        listItemC.profilePicture_base64
                                        :
                                        listItemC.profilePicture_uri
                                      ),
                                      socialOverlayData_bioString: listItemC.bioString,
                                      socialOverlayData_contractAddress: listItemC.contractLookupID,
                                      mediaMapArray: mediaMapArrayUserMap[listItemC.manager],
                                    })
                                  }}
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '20px', 
                                    position: 'absolute',
                                    marginTop: 0, 
                                    marginBottom: 0, 
                                    padding: 1,
                                    left: '4vw',
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                    // top: -7,
                                    zIndex: 99999,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                  
                                >
                                  {
                                    listItemC.profilePicture_base64
                                    ?
                                    <img 
                                      style={{
                                        width: '38px',
                                        height: '38px',
                                        borderRadius: '19px',
                                        zIndex: 99999,
                                        top: 1, 
                                        bottom: 1, 
                                        left: 1, 
                                        right: 1, 
                                        position: 'absolute',
                                        borderWidth: 1,
                                        borderStyle: 'none',
                                        objectFit: 'cover',
                                      }} 
                                      src={listItemC.profilePicture_base64}
                                    />
                                    :
                                    <img 
                                      style={{
                                        width: '38px',
                                        height: '38px',
                                        borderRadius: '19px',
                                        zIndex: 99999,
                                        top: 1, 
                                        bottom: 1, 
                                        left: 1, 
                                        right: 1, 
                                        position: 'absolute',
                                        borderWidth: 1,
                                        borderStyle: 'none',
                                        objectFit: 'cover',
                                        
                                      }} 
                                      src={listItemC.profilePicture_uri}
                                    />
                                  }
                                </Button>

                                <Link 
                                  to={`/borrowingacct/${listItemC.contractLookupID}`}
                                  state={{ contractAddress: `${listItemC.address}` }}
                                  disabled={listItemC.disabled}
                                  onClick={() => {
                                  }}
                                  style={{
                                    borderWidth: 0,
                                    display: 'flex',
                                    paddingLeft: '2vw',
                                    width: '55vw',
                                    height: '60px',
                                    paddingRight: 0,
                                    flexDirection: "row",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div 
                                    style={{
                                      width: '17vw',
                                      height: '20px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {String(listItemC.manager).toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="tbp-browse-credit-cell" 
                                    style={{
                                      width: '19vw',
                                      height: '20px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 34,
                                      flexDirection: 'row',
                                      display: 'flex',
                                    }}
                                  >

                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      // position: 'relative',
                                      marginTop: 10, 
                                      bottom: 0,
                                      left: 0, 
                                    }}>
                                      {`${listItemC.balance} USD`}
                                    </p>

                                    <div 
                                      style={{
                                        width: '10vw',
                                        height: '35px',
                                        marginLeft: '1vw',
                                        position: 'relative',
                                        top: '-1px', 
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        paddingLeft: 5,
                                        backgroundColor: 'rgba(63, 66, 72, 0)',


                                          // width: '40px',
                                          // height: '40px',
                                          // position: 'relative',
                                          // marginTop: 0, 
                                          // marginBottom: 0, 
                                          // padding: 1,
                                          // // top: -7,
                                          // zIndex: 999,
                                          // justifyContent: 'center',
                                          // alignItems: 'center',
                                      }}
                                    >
                                      <Chart
                                        chartType="LineChart"
                                        width="100%"
                                        height='35px'
                                        // style={{
                                        //   position: 'relative',
                                        //   // margin: 5,
                                        //   top: 0, 
                                        //   bottom: 0, 
                                        //   left: 0,
                                        //   zIndex: 99999,
                                        // }} 
                                        data={ listItemC.values }
                                        options={{
                                          series: [{ color: "#009e81" }],
                                          lineWidth: 2,
                                          intervals: { style: "line" },
                                          legend: "none",
                                          curveType: "function",
                                          backgroundColor: 'transparent',
                                          enableInteractivity: false,
                                          // chartArea: { backgroundColor: 'transparent', },
                                          tooltip : {
                                            trigger: 'none'
                                          },
                                          hAxis: { 
                                            gridlines: {
                                              color: 'transparent'
                                            },
                                            baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                          },
                                          vAxis: { 
                                            gridlines: {
                                              color: 'transparent'
                                            },
                                            baselineColor: '#5d626b',
                                            viewWindow: { min: listItemC.xMin, max: listItemC.xMax } 
                                          },
                                      }}
                                    />
                                    </div>

                                  
                                  </div>
                                  <div 
                                    style={{
                                      width: '9vw',
                                      height: '20px', 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {`${listItemC.lenderCt} `}
                                      <i style={{fontSize: 11, marginBottom: 1, }} className="user icon"></i>
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '9vw',
                                      height: '20px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {`${listItemC.intRate}`}
                                    </p>
                                  </div>
                                </Link>
                            
                              </div>
                          ))}
                                              </React.Fragment>
                      </div>
                    </div>
                  )}

                  {that.state.searchSubmitted && !that.state.searchActivityBool && that.state.searchLookupFailed && (
                    <div className="tbp-browser-search__no-results" role="alert">
                      <h3>{that.state.selectedLanguage === 'spanish' ? 'No se pudo completar la búsqueda' : 'Search Unavailable'}</h3>
                      <p>{that.state.selectedLanguage === 'spanish' ? 'Comprueba tu conexión y vuelve a intentarlo.' : 'Please check your connection and try again.'}</p>
                    </div>
                  )}
                  {that.state.searchSubmitted && !that.state.searchActivityBool && !that.state.searchLookupFailed && (!that.state.searchedContractsArray || that.state.searchedContractsArray.length === 0) && (
                    <div className="tbp-browser-search__no-results" role="status" aria-live="polite">
                      <i className="search icon" aria-hidden="true" />
                      <h3>{that.state.selectedLanguage === 'spanish' ? 'Sin resultados' : 'No Results'}</h3>
                      <p>{that.state.selectedLanguage === 'spanish'
                        ? 'No se encontró una línea de crédito para ese usuario.'
                        : 'No credit line exists for this username.'}</p>
                    </div>
                  )}

                  <div className="tbp-browser-section tbp-browser-active">
                    <div className="tbp-browser-section-title">
                      <h2>{that.state.selectedLanguage === 'spanish' ? "Todas las Cuentas Activas" : "All Active Accounts"}</h2>
                    </div>
                    <div className="tbp-browser-list-container">
                      <div className="tbp-credit-header" 
                          style={{
                            display: 'flex',
                            width: '55vw',
                            height: '40px',
                            borderTopLeftRadius: '3px',
                            borderTopRightRadius: '3px',
                            paddingLeft: '2vw',
                            flexDirection: "row",
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                          }}
                        >
                          <div 
                            style={{
                              width: '17vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'PRESTATARIO'
                                :
                                'BORROWER'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '19vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'CRÉDITO DISPONIBLE'
                                :
                                'AVAILABLE CREDIT'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '9vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'PRESTADORES'
                                :
                                'LENDER(S)'
                              }
                            </p>
                          </div>
                          <div 
                            style={{
                              width: '9vw',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 45,
                            }}
                          >
                            <p style={{ 
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'left',
                              textAlignVertical: 'center',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              fontSize: 13,
                              fontWeight: '600',
                              left: 0, 
                            }}>
                              {'APR.'}
                            </p>
                          </div>
                        </div>
                      <React.Fragment>
                          {that.state.creditLineArray.map(listItemD => (
                          
                              
                              <div className="tbp-credit-row tbp-credit-row--browse" 
                                style={{
                                  borderWidth: 0,
                                  display: 'flex',
                                  width: '55vw',
                                  height: '60px',
                                  paddingRight: 0,
                                  flexDirection: "row",
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                }}
                              >


                                <Button
                                  onClick={() => {
                                    that.setState({
                                      socialOverlay: true,
                                      socialOverlayData_username: listItemD.manager,
                                      socialOverlayData_displayName: listItemD.displayName,
                                      socialOverlayData_fullName: listItemD.fullName,
                                      socialOverlayData_imageURI: (
                                        listItemD.profilePicture_base64
                                        ?
                                        listItemD.profilePicture_base64
                                        :
                                        listItemD.profilePicture_uri
                                      ),
                                      socialOverlayData_bioString: listItemD.bioString,
                                      socialOverlayData_contractAddress: listItemD.contractLookupID,
                                      mediaMapArray: mediaMapArrayUserMap[listItemD.manager],
                                    })
                                  }}
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '20px', 
                                    position: 'absolute',
                                    marginTop: 0, 
                                    marginBottom: 0, 
                                    padding: 1,
                                    left: '4vw',
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                    // top: -7,
                                    zIndex: 99999,
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                  
                                >
                                  {
                                    listItemD.profilePicture_base64
                                    ?
                                    <img 
                                      style={{
                                        width: '38px',
                                        height: '38px',
                                        borderRadius: '19px',
                                        zIndex: 99999,
                                        top: 1, 
                                        bottom: 1, 
                                        left: 1, 
                                        right: 1, 
                                        position: 'absolute',
                                        borderWidth: 1,
                                        borderStyle: 'none',
                                        objectFit: 'cover',
                                      }} 
                                      src={listItemD.profilePicture_base64}
                                    />
                                    :
                                    <img 
                                      style={{
                                        width: '38px',
                                        height: '38px',
                                        borderRadius: '19px',
                                        zIndex: 99999,
                                        top: 1, 
                                        bottom: 1, 
                                        left: 1, 
                                        right: 1, 
                                        position: 'absolute',
                                        borderWidth: 1,
                                        borderStyle: 'none',
                                        objectFit: 'cover',
                                        
                                      }} 
                                      src={listItemD.profilePicture_uri}
                                    />
                                  }
                                </Button>

                                <Link 
                                  to={`/borrowingacct/${listItemD.contractLookupID}`}
                                  state={{ contractAddress: `${listItemD.address}` }}
                                  disabled={listItemD.disabled}
                                  onClick={() => {
                                  }}
                                  style={{
                                    borderWidth: 0,
                                    display: 'flex',
                                    paddingLeft: '2vw',
                                    width: '55vw',
                                    height: '60px',
                                    paddingRight: 0,
                                    flexDirection: "row",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                  }}
                                >
                                  <div 
                                    style={{
                                      width: '17vw',
                                      height: '20px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {String(listItemD.manager).toUpperCase()}
                                    </p>
                                  </div>
                                  <div className="tbp-browse-credit-cell" 
                                    style={{
                                      width: '19vw',
                                      height: '20px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 34,
                                      flexDirection: 'row',
                                      display: 'flex',
                                    }}
                                  >

                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      // position: 'relative',
                                      marginTop: 10, 
                                      bottom: 0,
                                      left: 0, 
                                    }}>
                                      {`${listItemD.balance} USD`}
                                    </p>

                                    <div 
                                      style={{
                                        width: '10vw',
                                        height: '35px',
                                        marginLeft: '1vw',
                                        position: 'relative',
                                        top: '-1px', 
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        paddingLeft: 5,
                                        backgroundColor: 'rgba(63, 66, 72, 0)',


                                          // width: '40px',
                                          // height: '40px',
                                          // position: 'relative',
                                          // marginTop: 0, 
                                          // marginBottom: 0, 
                                          // padding: 1,
                                          // // top: -7,
                                          // zIndex: 999,
                                          // justifyContent: 'center',
                                          // alignItems: 'center',
                                      }}
                                    >
                                      <Chart
                                        chartType="LineChart"
                                        width="100%"
                                        height='35px'
                                        // style={{
                                        //   position: 'relative',
                                        //   // margin: 5,
                                        //   top: 0, 
                                        //   bottom: 0, 
                                        //   left: 0,
                                        //   zIndex: 99999,
                                        // }} 
                                        data={ listItemD.values }
                                        options={{
                                          series: [{ color: "#009e81" }],
                                          lineWidth: 2,
                                          intervals: { style: "line" },
                                          legend: "none",
                                          curveType: "function",
                                          backgroundColor: 'transparent',
                                          enableInteractivity: false,
                                          // chartArea: { backgroundColor: 'transparent', },
                                          tooltip : {
                                            trigger: 'none'
                                          },
                                          hAxis: { 
                                            gridlines: {
                                              color: 'transparent'
                                            },
                                            baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                          },
                                          vAxis: { 
                                            gridlines: {
                                              color: 'transparent'
                                            },
                                            baselineColor: '#5d626b',
                                            viewWindow: { min: listItemD.xMin, max: listItemD.xMax } 
                                          },
                                      }}
                                    />
                                    </div>

                                  
                                  </div>
                                  <div 
                                    style={{
                                      width: '9vw',
                                      height: '20px', 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {`${listItemD.lenderCt} `}
                                      <i style={{fontSize: 11, marginBottom: 1, }} className="user icon"></i>
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '9vw',
                                      height: '20px',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: 20, 
                                      marginBottom: 20,
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      fontSize: 14,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {`${listItemD.intRate}`}
                                    </p>
                                  </div>
                                </Link>
                            
                              </div>
                          ))}
                      </React.Fragment>









                      {/* //LENDING */}
                      












                    </div>
</div>
                  <div className="tbp-browser-section tbp-browser-recent">
                        <div className="tbp-browser-section-title">
                      <h2>{that.state.selectedLanguage === 'spanish' ? "Cuentas Vistas Recientemente" : "Recently Viewed Accounts"}</h2>
                    </div>
                    <div className="tbp-browser-list-container">
                          <div className="tbp-credit-header"
                              style={{
                                display: 'flex',
                                width: '55vw',
                                minHeight: 50,
                                borderTopLeftRadius: '3px',
                                borderTopRightRadius: '3px',
                                paddingLeft: '2vw',
                                flexDirection: "row",
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                              }}
                            >
                              <div 
                                style={{
                                  width: '17vw',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingLeft: 45,
                                }}
                              >
                                <p style={{
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 13,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'PRESTATARIO'
                                    :
                                    'BORROWER'
                                  }
                                </p>
                              </div>
                              <div 
                                style={{
                                  width: '19vw',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingLeft: 45,
                                }}
                              >
                                <p style={{ 
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 13,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'CRÉDITO DISPONIBLE'
                                    :
                                    'AVAILABLE CREDIT'
                                  }
                                </p>
                              </div>
                              <div 
                                style={{
                                  width: '9vw',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingLeft: 45,
                                }}
                              >
                                <p style={{ 
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 13,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'PRESTADORES'
                                    :
                                    'LENDER(S)'
                                  }
                                </p>
                              </div>
                              <div 
                                style={{
                                  width: '9vw',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  paddingLeft: 45,
                                }}
                              >
                                <p style={{ 
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  textAlign: 'left',
                                  textAlignVertical: 'center',
                                  color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                  fontSize: 13,
                                  fontWeight: '600',
                                  left: 0, 
                                }}>
                                  {'APR.'}
                                </p>
                              </div>
                            </div>
                          <React.Fragment>
                              {that.state.recentlyViewedContractsArray.map(listItemF => (
                              
                                  
                                  <div className="tbp-credit-row tbp-credit-row--browse"
                                    style={{
                                      borderWidth: 0,
                                      display: 'flex',
                                      width: '55vw',
                                      height: '60px',
                                      paddingRight: 0,
                                      flexDirection: "row",
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                    }}
                                  >


                                    <Button
                                      onClick={() => {
                                        that.setState({
                                          socialOverlay: true,
                                          socialOverlayData_username: listItemF.manager,
                                          socialOverlayData_displayName: listItemF.displayName,
                                          socialOverlayData_fullName: listItemF.fullName,
                                          socialOverlayData_imageURI: (
                                            listItemF.profilePicture_base64
                                            ?
                                            listItemF.profilePicture_base64
                                            :
                                            listItemF.profilePicture_uri
                                          ),
                                          socialOverlayData_bioString: listItemF.bioString,
                                          socialOverlayData_contractAddress: listItemF.contractLookupID,
                                          mediaMapArray: mediaMapArrayUserMap[listItemF.manager],
                                        })
                                      }}
                                      style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '20px', 
                                        position: 'absolute',
                                        marginTop: 0, 
                                        marginBottom: 0, 
                                        padding: 1,
                                        left: '4vw',
                                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                        // top: -7,
                                        zIndex: 99999,
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                      
                                    >
                                      {
                                        listItemF.profilePicture_base64
                                        ?
                                        <img 
                                          style={{
                                            width: '38px',
                                            height: '38px',
                                            borderRadius: '19px',
                                            zIndex: 99999,
                                            top: 1, 
                                            bottom: 1, 
                                            left: 1, 
                                            right: 1, 
                                            position: 'absolute',
                                            borderWidth: 1,
                                            borderStyle: 'none',
                                            objectFit: 'cover',
                                          }} 
                                          src={listItemF.profilePicture_base64}
                                        />
                                        :
                                        <img 
                                          style={{
                                            width: '38px',
                                            height: '38px',
                                            borderRadius: '19px',
                                            zIndex: 99999,
                                            top: 1, 
                                            bottom: 1, 
                                            left: 1, 
                                            right: 1, 
                                            position: 'absolute',
                                            borderWidth: 1,
                                            borderStyle: 'none',
                                            objectFit: 'cover',
                                            
                                          }} 
                                          src={listItemF.profilePicture_uri}
                                        />
                                      }
                                    </Button>
                                    <Link 
                                      to={`/borrowingacct/${listItemF.contractLookupID}`}
                                      state={{ contractAddress: `${listItemF.address}` }}
                                      disabled={listItemF.disabled}
                                      onClick={() => {
                                      }}
                                      style={{
                                        borderWidth: 0,
                                        display: 'flex',
                                        paddingLeft: '2vw',
                                        width: '55vw',
                                        height: '60px',
                                        paddingRight: 0,
                                        flexDirection: "row",
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div 
                                        style={{
                                          width: '17vw',
                                          height: '20px',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: 45,
                                        }}
                                      >
                                        <p style={{
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 14,
                                          fontWeight: '600',
                                          left: 0, 
                                        }}>
                                          {String(listItemF.manager).toUpperCase()}
                                        </p>
                                      </div>
                                      <div className="tbp-browse-credit-cell" 
                                        style={{
                                          width: '19vw',
                                          height: '20px',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: 34,
                                          flexDirection: 'row',
                                          display: 'flex',
                                        }}
                                      >

                                        <p style={{ 
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 14,
                                          fontWeight: '600',
                                          // position: 'relative',
                                          marginTop: 10, 
                                          bottom: 0,
                                          left: 0, 
                                        }}>
                                          {`${listItemF.balance} USD`}
                                        </p>

                                        <div 
                                          style={{
                                            width: '10vw',
                                            height: '35px',
                                            marginLeft: '1vw',
                                            position: 'relative',
                                            top: '-1px', 
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            paddingLeft: 5,
                                            backgroundColor: 'rgba(63, 66, 72, 0)',


                                              // width: '40px',
                                              // height: '40px',
                                              // position: 'relative',
                                              // marginTop: 0, 
                                              // marginBottom: 0, 
                                              // padding: 1,
                                              // // top: -7,
                                              // zIndex: 999,
                                              // justifyContent: 'center',
                                              // alignItems: 'center',
                                          }}
                                        >
                                          <Chart
                                            chartType="LineChart"
                                            width="100%"
                                            height='35px'
                                            // style={{
                                            //   position: 'relative',
                                            //   // margin: 5,
                                            //   top: 0, 
                                            //   bottom: 0, 
                                            //   left: 0,
                                            //   zIndex: 99999,
                                            // }} 
                                            data={ listItemF.values }
                                            options={{
                                              series: [{ color: "#009e81" }],
                                              lineWidth: 2,
                                              intervals: { style: "line" },
                                              legend: "none",
                                              curveType: "function",
                                              backgroundColor: 'transparent',
                                              enableInteractivity: false,
                                              // chartArea: { backgroundColor: 'transparent', },
                                              tooltip : {
                                                trigger: 'none'
                                              },
                                              hAxis: { 
                                                gridlines: {
                                                  color: 'transparent'
                                                },
                                                baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                              },
                                              vAxis: { 
                                                gridlines: {
                                                  color: 'transparent'
                                                },
                                                baselineColor: '#5d626b',
                                                viewWindow: { min: listItemF.xMin, max: listItemF.xMax } 
                                              },
                                          }}
                                        />
                                        </div>

                                      
                                      </div>
                                      <div 
                                        style={{
                                          width: '9vw',
                                          height: '20px', 
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: 45,
                                        }}
                                      >
                                        <p style={{ 
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 14,
                                          fontWeight: '600',
                                          left: 0, 
                                        }}>
                                          {`${listItemF.lenderCt} `}
                                          <i style={{fontSize: 11, marginBottom: 1, }} className="user icon"></i>
                                        </p>
                                      </div>
                                      <div 
                                        style={{
                                          width: '9vw',
                                          height: '20px',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          marginTop: 20, 
                                          marginBottom: 20,
                                          paddingLeft: 45,
                                        }}
                                      >
                                        <p style={{ 
                                          justifyContent: 'center',
                                          textAlign: 'left',
                                          textAlignVertical: 'center',
                                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                          fontSize: 14,
                                          fontWeight: '600',
                                          left: 0, 
                                        }}>
                                          {`${listItemF.intRate}`}
                                        </p>
                                      </div>
                                    </Link>

                                  </div>
                              ))}
                          </React.Fragment>






                          









                        </div>
                      </div>
<div className="tbp-browser-section tbp-browser-saved">
                            <div className="tbp-browser-section-title">
                      <h2>{that.state.selectedLanguage === 'spanish' ? "Cuentas Guardadas" : "Saved Accounts"}</h2>
                    </div>
                    <div className="tbp-browser-list-container">
                              <div className="tbp-credit-header" 
                                  style={{
                                    display: 'flex',
                                    width: '55vw',
                                    height: '40px',
                                    borderTopLeftRadius: '3px',
                                    borderTopRightRadius: '3px',
                                    paddingLeft: '2vw',
                                    flexDirection: "row",
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(35, 35, 35, 1)', 
                                  }}
                                >
                                  <div 
                                    style={{
                                      width: '17vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 13,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'PRESTATARIO'
                                        :
                                        'BORROWER'
                                      }
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '19vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 13,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'CRÉDITO DISPONIBLE'
                                        :
                                        'AVAILABLE CREDIT'
                                      }
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '9vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 13,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'PRESTADORES'
                                        :
                                        'LENDER(S)'
                                      }
                                    </p>
                                  </div>
                                  <div 
                                    style={{
                                      width: '9vw',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      paddingLeft: 45,
                                    }}
                                  >
                                    <p style={{ 
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 13,
                                      fontWeight: '600',
                                      left: 0, 
                                    }}>
                                      {'APR.'}
                                    </p>
                                  </div>
                                </div>
                              <React.Fragment>
                                  {that.state.wishlistArray.map(listItemH => (
                                  
                                      
                                      <div className="tbp-credit-row tbp-credit-row--browse"
                                        style={{
                                          borderWidth: 0,
                                          display: 'flex',
                                          width: '55vw',
                                          height: '60px',
                                          paddingRight: 0,
                                          flexDirection: "row",
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        }}
                                      >


                                        <Button
                                          style={{
                                            width: '40px',
                                            height: '40px',
                                            borderRadius: '20px', 
                                            position: 'absolute',
                                            marginTop: 0, 
                                            marginBottom: 0, 
                                            padding: 1,
                                            left: '4vw',
                                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.3)',
                                            // top: -7,
                                            zIndex: 99999,
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                          onClick={() => {
                                            that.setState({
                                              socialOverlay: true,
                                              socialOverlayData_username: listItemH.manager,
                                              socialOverlayData_displayName: listItemH.displayName,
                                              socialOverlayData_fullName: listItemH.fullName,
                                              socialOverlayData_imageURI: (
                                                listItemH.profilePicture_base64
                                                ?
                                                listItemH.profilePicture_base64
                                                :
                                                listItemH.profilePicture_uri
                                              ),
                                              socialOverlayData_bioString: listItemH.bioString,
                                              socialOverlayData_contractAddress: listItemH.contractLookupID,
                                              mediaMapArray: mediaMapArrayUserMap[listItemH.manager],
                                            })
                                          }}
                                        >
                                          {
                                            listItemH.profilePicture_base64
                                            ?
                                            <img 
                                              style={{
                                                width: '38px',
                                                height: '38px',
                                                borderRadius: '19px',
                                                zIndex: 99999,
                                                top: 1, 
                                                bottom: 1, 
                                                left: 1, 
                                                right: 1, 
                                                position: 'absolute',
                                                borderWidth: 1,
                                                borderStyle: 'none',
                                                objectFit: 'cover',
                                              }} 
                                              src={listItemH.profilePicture_base64}
                                            />
                                            :
                                            <img 
                                              style={{
                                                width: '38px',
                                                height: '38px',
                                                borderRadius: '19px',
                                                zIndex: 99999,
                                                top: 1, 
                                                bottom: 1, 
                                                left: 1, 
                                                right: 1, 
                                                position: 'absolute',
                                                borderWidth: 1,
                                                borderStyle: 'none',
                                                objectFit: 'cover',
                                                
                                              }} 
                                              src={listItemH.profilePicture_uri}
                                            />
                                          }
                                        </Button>
                                        <Link 
                                          to={`/borrowingacct/${listItemH.contractLookupID}`}
                                          state={{ contractAddress: `${listItemH.address}` }}
                                          disabled={listItemH.disabled}
                                          onClick={() => {
                                          }}
                                          style={{
                                            borderWidth: 0,
                                            display: 'flex',
                                            paddingLeft: '2vw',
                                            width: '55vw',
                                            height: '60px',
                                            paddingRight: 0,
                                            flexDirection: "row",
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <div 
                                            style={{
                                              width: '17vw',
                                              height: '20px',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: 45,
                                            }}
                                          >
                                            <p style={{
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 14,
                                              fontWeight: '600',
                                              left: 0, 
                                            }}>
                                              {String(listItemH.manager).toUpperCase()}
                                            </p>
                                          </div>
                                          <div className="tbp-browse-credit-cell" 
                                            style={{
                                              width: '19vw',
                                              height: '20px',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: 34,
                                              flexDirection: 'row',
                                              display: 'flex',
                                            }}
                                          >

                                            <p style={{ 
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 14,
                                              fontWeight: '600',
                                              // position: 'relative',
                                              marginTop: 10, 
                                              bottom: 0,
                                              left: 0, 
                                            }}>
                                              {`${listItemH.balance} USD`}
                                            </p>

                                            <div 
                                              style={{
                                                width: '10vw',
                                                height: '35px',
                                                marginLeft: '1vw',
                                                position: 'relative',
                                                top: '-1px', 
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                paddingLeft: 5,
                                                backgroundColor: 'rgba(63, 66, 72, 0)',


                                                  // width: '40px',
                                                  // height: '40px',
                                                  // position: 'relative',
                                                  // marginTop: 0, 
                                                  // marginBottom: 0, 
                                                  // padding: 1,
                                                  // // top: -7,
                                                  // zIndex: 999,
                                                  // justifyContent: 'center',
                                                  // alignItems: 'center',
                                              }}
                                            >
                                              <Chart
                                                chartType="LineChart"
                                                width="100%"
                                                height='35px'
                                                // style={{
                                                //   position: 'relative',
                                                //   // margin: 5,
                                                //   top: 0, 
                                                //   bottom: 0, 
                                                //   left: 0,
                                                //   zIndex: 99999,
                                                // }} 
                                                data={ listItemH.values }
                                                options={{
                                                  series: [{ color: "#009e81" }],
                                                  lineWidth: 2,
                                                  intervals: { style: "line" },
                                                  legend: "none",
                                                  curveType: "function",
                                                  backgroundColor: 'transparent',
                                                  enableInteractivity: false,
                                                  // chartArea: { backgroundColor: 'transparent', },
                                                  tooltip : {
                                                    trigger: 'none'
                                                  },
                                                  hAxis: { 
                                                    gridlines: {
                                                      color: 'transparent'
                                                    },
                                                    baselineColor: that.state.mode_light_dark == 'light' ? '#ffffff' : '#5d626b',
                                                  },
                                                  vAxis: { 
                                                    gridlines: {
                                                      color: 'transparent'
                                                    },
                                                    baselineColor: '#5d626b',
                                                    viewWindow: { min: listItemH.xMin, max: listItemH.xMax } 
                                                  },
                                              }}
                                            />
                                            </div>

                                          
                                          </div>
                                          <div 
                                            style={{
                                              width: '9vw',
                                              height: '20px', 
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: 45,
                                            }}
                                          >
                                            <p style={{ 
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 14,
                                              fontWeight: '600',
                                              left: 0, 
                                            }}>
                                              {`${listItemH.lenderCt} `}
                                              <i style={{fontSize: 11, marginBottom: 1, }} className="user icon"></i>
                                            </p>
                                          </div>
                                          <div 
                                            style={{
                                              width: '9vw',
                                              height: '20px',
                                              justifyContent: 'center',
                                              alignItems: 'center',
                                              marginTop: 20, 
                                              marginBottom: 20,
                                              paddingLeft: 45,
                                            }}
                                          >
                                            <p style={{ 
                                              justifyContent: 'center',
                                              textAlign: 'left',
                                              textAlignVertical: 'center',
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                              fontSize: 14,
                                              fontWeight: '600',
                                              left: 0, 
                                            }}>
                                              {`${listItemH.intRate}`}
                                            </p>
                                          </div>
                                        </Link>
                                      </div>
                                  ))}
                              </React.Fragment>

                              
                              <div 
                                style={{
                                  height: 25,
                                }}
                              />
                            </div>
                          </div>



                  

                  <PlatformFooter language={that.state.selectedLanguage} />


                </div>  


                <div className="tbp-money-rail" style={{
                  alignItems: 'center',
                  width: '25vw',
                  position: 'fixed',
                  right: 0,
                  // top: 0, 
                  // bottom: 0, 
                  height: '93vh',
                  marginTop: 0,
                  marginBottom: 0,
                  marginRight: 0,
                  marginLeft: '65vw',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderLeftStyle: 'solid',
                  borderWidth: 0.1,
                  borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',

                }}>
                    <div
                      style={{
                        marginBottom: 25,
                        height: '93vh',
                        marginTop: 0,
                        width: '25vw',
                        borderRadius: 0,
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 14, 
                        fontWeight: '600',
                      }}
                      // disabled={true}
                    >
                      <div
                        style={{
                          flexDirection: 'row',
                          display: 'flex',
                          width: '25vw',
                        }}
                      >
                        <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "deposit"}
                          onClick={() => {
                            that.setState({
                              moneyTransactionPreset: 'deposit'
                            })
                          }}
                          style={{
                            backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'deposit' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                            width: '8.33vw',
                            height: '5.3vh',
                            // borderTopLeftRadius: '5px',
                            // borderBottomLeftRadius: '5px',
                            borderColor: 'rgba(177, 177, 177, 0)',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: 0, 
                            marginRight: 0,
                            paddingLeft: 10, 
                            paddingRight: 10,
                            borderRightStyle: 'none',
                            borderWidth: 0.1,
                            borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                            borderRadius: 0,
                          }}
                        >
                          <p
                            style={{
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                              textAlign: 'center',
                              textAlignVertical: 'center',
                              fontSize: 16,
                              fontWeight: '600',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Depositar'
                              :
                              'Deposit'
                            }
                          </p>
                        </Button>
                        <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "transfer"}
                          onClick={() => {
                            that.setState({
                              moneyTransactionPreset: 'transfer'
                            })
                          }}
                          style={{
                            backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'transfer' ? 
                            (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                            width: '8.33vw',
                            height: '5.3vh',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: 0, 
                            marginRight: 0,
                            paddingLeft: 10, 
                            paddingRight: 10,
                            borderRightStyle: 'none',
                            borderWidth: 0.1,
                            borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                            borderRadius: 0,
                          }}
                        >
                          <p
                            style={{
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                              textAlign: 'center',
                              textAlignVertical: 'center',
                              fontSize: 16,
                              fontWeight: '600',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Transferir'
                              :
                              'Transfer'
                            }
                          </p>
                        </Button>
                        <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "withdraw"}
                          onClick={() => {
                            that.setState({
                              moneyTransactionPreset: 'withdraw'
                            })
                          }}
                          style={{
                            backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'withdraw' ? 
                            (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                              : 
                              (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                            width: '8.33vw',
                            height: '5.3vh',
                            borderTopRightRadius: '5px',
                            borderBottomRightRadius: '5px',
                            borderColor: 'rgba(177, 177, 177, 0)',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: 0, 
                            marginRight: 0,
                            paddingLeft: 10, 
                            paddingRight: 15,
                            borderRadius: 0,
                          }}
                        >
                          <p
                            style={{
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                              textAlign: 'center',
                              textAlignVertical: 'center',
                              fontSize: 16,
                              fontWeight: '600',
                            }}
                          >
                            {that.state.selectedLanguage == 'spanish' ? 
                              'Retirar'
                              :
                              'Withdraw'
                            }
                          </p>
                        </Button>
                      </div>
{['deposit','withdraw'].includes(that.state.moneyTransactionPreset) ? <CryptoMoneyPanel desktop balanceWei={that.state.walletBalanceWei} key={that.state.moneyTransactionPreset} mode={that.state.moneyTransactionPreset} theme={that.state.mode_light_dark} language={that.state.selectedLanguage} onComplete={() => { if(publicKey)trackPageRequest(web3.eth.getBalance(publicKey)).then(balance => that.setState({walletBalanceWei: balance, walletBalanceUSD: Number(balance) / 1000000000000000000})).catch(() => {}); }} /> : <DesktopTransferPanel
    language={that.state.selectedLanguage}
    theme={that.state.mode_light_dark}
    amount={that.state.moneyTransactionLiveValue}
    recipient={that.state.destinationUsername}
    usernames={that.state.allUserUsernamesDisplayNames}
    balanceWei={that.state.walletBalanceWei}
    commissionRate={that.state.transferCommissionPercentDecimal}
    onAmountChange={(value) => that.setState({ moneyTransactionLiveValue: value })}
    onRecipientChange={(value) => that.setState({
      destinationUsername: value,
      activeSearchTransferBool: String(value).length >= 2,
      showSearchDropDownMenuBool: String(value).length >= 2,
    })}
    onContinue={(username, value) => that.setState({
      destinationUsername: username.toUpperCase(),
      moneyTransactionLiveValue: String(value),
      passwordText: '',
      transactionConfirmationMessage: that.state.selectedLanguage === 'spanish'
        ? `Confirma la transferencia de ${Number(value).toFixed(2)} USD a ${username.toUpperCase()}.`
        : `Confirm transfer of ${Number(value).toFixed(2)} USD to ${username.toUpperCase()}.`,
      showPasswordOverlay: true,
    })}
  />}
</div>

                </div> 


                
              </div>


            </div>



          </div>
        )
    );
  }
}

export default BrowserDesktopRender;
